module.exports = __webpack_public_path__ + "static/img/xinyin-logo.dad76ff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xinyin-logo.png
// module id = Vk1B
// module chunks = 1